/**
 * Les deux sites construits à partir de ce code.
 *
 * Le site OmnIA est celui des agents : conversations, Cowork, réunions,
 * projets. L'administration du PEV — la mémoire du programme, les comptes, les
 * paramètres — vit à une adresse à part, réservée aux administrateurs : un
 * agent n'a pas à la voir, et elle se gère sans toucher au site de travail.
 *
 * Le même code sert les deux ; c'est la construction qui décide
 * (REACT_APP_ESPACE=admin), ou à défaut un nom d'hôte commençant par
 * « admin. ».
 */
const hote = typeof window !== 'undefined' ? window.location.hostname : '';

export const ESPACE_ADMIN =
  process.env.REACT_APP_ESPACE === 'admin' || hote.startsWith('admin.');

const sansBarreFinale = (url?: string) => (url || '').trim().replace(/\/$/, '');

/** Adresse du site OmnIA des agents, vue depuis l'administration. */
export const URL_OMNIA = sansBarreFinale(process.env.REACT_APP_URL_OMNIA);

/** Adresse du site d'administration du PEV, vue depuis OmnIA. */
export const URL_ADMIN = sansBarreFinale(process.env.REACT_APP_URL_ADMIN);

/** Première page après la connexion. */
export const ACCUEIL = ESPACE_ADMIN ? '/workspace/memoire' : '/workspace/conversations';
